//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmSpisovyZnak.ts						</Name>
//    <Description> Dialog seznam Spisov� znak										</Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-02-11                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.11.4
//AdtGeneratorConfig:[ T:(sslsspz) GID:(Web.Set.Ts) V1:(spis_pl,spis_znak) V2:() K1:() K2:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
    export class SeznamAdmSpisovyZnak extends GContentBase<SeznamAdmSpisovyZnakDesigner>  {
		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
        private init() {

            // inicializace hodnot od rodice
            SeznamAdmSpisovyZnakDesigner.SeznamAdmSpisovyZnakDesignerInit(this, this.spis_pl, "" );

			this.setTitle();
			this.createMenuButtons();
			this.createTabManager();
			this.createGrid();
			this.createTreeGrid();
            this.createMenuBar();
			this.createSidebar();
			this.tabmanager.gtabmanager("refresh");
		}

		/** nastavit titulek dialogu */
		private setTitle() {
                this.title = "jres:29808067" 	//RC 29808067 : Spisov� znak
		}

		private createTabManager() {
			this.tabmanager = $("<div>")
				.appendTo(this.element)
				.gtabmanager({
					groups: [ 
						{
							id: "tabList",
							caption: "jres:32131039", //RC 33000314 : Seznam
						},
						{
							id: "tabTree",
							caption: "jres:33000059", //RC 33000059 : Strom
						},
					]
				})
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			var bar = this.setMenuButtons();
			return bar;
		}

		/**
		 * createMenuButtons
		 */
        private createMenuButtons(): void {
            this.novyZaznamButton();
			this.detailButton();
		}

		/**
		 * vytvo�it menu
		 */
		private createMenuBar(): void {
			this.menuBar(this.setMenuButtons());
		}

		private setMenuButtons(): MenuParams[] {

			const bar: MenuParams[] = [];

            bar.push({
                favorite: true,
                primary: true,
                action: this.actions.actNovy
            })

			bar.push({
				favorite: true,
				action: this.actions.actDetail
			})

			bar.push({
				favorite: true,
				action: this.actions.actImport
			})

			return bar;
        }

        private novyZaznamButton() {
            this.actions.add(new GAction({
                name: "actNovy",
                icon: "gi-plus",
                caption: "jres:32000121",			//RC 32000121 : Nov� z�znam
                run: () => {
                    var newRecord = true;
                    this.openDetail(newRecord);
                }
            }));
        }

		/**
		 * detail button
		 */
		private detailButton(): void {
			this.actions.add(new GAction({
				name: "actDetail",
				icon: "gi-detail",
				caption: "jres:32131033",			//RC 32131033 : Detail
				run: () => {
					this.openDetail();
				}
			}));

			this.actions.add(new GAction({
				name: "actImport",
				icon: "fa-upload",
				caption: "jres:33000651", //RC 33000651 : Import spisov�ch znak�
				run: () => {
					this.dialogs.showModalWindow(["Gordic.Adm.WebControls.ImportAdmSpisovyZnak"], { ID: "ImportAdmSpisovyZnak" }, "", 1000, 600)
				}
			}))
		}


		//#endregion

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
        private openDetail(_new?: boolean): void {

			var newRecord = _new == null ? false : _new;
			var activeTab = this.tabmanager.gtabmanager("getActive");

            if (Utils.isGridEmpty(this.grid)) {

                if (newRecord === true) {
					// nov� z�znam p�i pr�zdn�m gridu
					Dialogs.DetailAdmSpisovyZnakDlg(this, { spis_pl: null, spis_znak: null, grid: (activeTab == "tabList") ? this.grid : this.treegrid, newRecord: newRecord }).done((data: any) => {
                        //this.reloadDataOnGrid();
                    });
                }
                else {
                    this.showFlash("jres:32131036", "g-state-warning", 2500, "id-flash-empty-grid-detail"); //RC 32131036 : Seznam je pr�zdn�, nelze p�ej�t na detail.
                }
			}
			else {
				var selection: any;
				if (activeTab == "tabList") 
					selection = this.grid.ggrid("getSelection");
				else
					selection = this.treegrid.ggrid("getSelection");

                // vybran� jeden ��dek
				if (selection.length === 1) {
                    var data: any = selection[0];
					Dialogs.DetailAdmSpisovyZnakDlg(this, { spis_pl: data.spis_pl, spis_znak: data.spis_znak, grid: (activeTab == "tabList") ? this.grid : this.treegrid, newRecord: newRecord }).done((data: any) => {
						//this.reloadDataOnGrid();		// t.hazmuka: hazel chybu sidebaru a vyhodnotil jsem, ze tu neni potreba, kdyz je refresh i v menu
					});
                }

				// vybr�no v�ce ��dk�
				else {
					this.showFlash("jres:32131037", "g-state-warning", 2500, "id-flash-select-more-rows-grid-detail"); //RC 32131037 : Nelze p�ej�t na detail s v�ce vybran�mi ��dky.
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {

			var tabList = $("<div>")
				.appendTo(this.element)
				.ggroupable({
					group: {
						id: "tabList"
					},
					conceal: (ev, ctx) => {
						this.grid.toggle(!ctx.conceal);
						var filterData = this.filter.gfilterpanel("getCurrentData");
						var filter = { filter: filterData };
						SeznamAdmSpisovyZnakDesigner.applyAction(this, null, filter, true);
					}
				})

            this.grid = $("<div>").gautofit().appendTo(tabList);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				dataKey: "spis_pl,spis_znak",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
					name: "doubleClickGridSeznam",
					run: (ev, ctx) => {
						this.openDetail();
					}
				}),
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
                sort: "spis_pl,spis_znak",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		private createTreeGrid() {
			var tabTree = $("<div>")
				.appendTo(this.element)
				.ggroupable({
					group: {
						id: "tabTree"
					},
					conceal: (ev, ctx) => {
						this.treegrid.toggle(!ctx.conceal);
						var filterData = this.filter.gfilterpanel("getCurrentData");
						var filter = { filter: filterData };
						SeznamAdmSpisovyZnakDesigner.applyAction(this, null, filter, true);
					}
				})

			this.treegrid = $("<div>").gautofit().appendTo(tabTree);

			var structureColumn = new Data.GridFormat()
				.addStructureColumn({
					name: "spis_znak",
					caption: this.gridFormat.get("spis_znak").caption,
					width: 140
				})
			var treeGridFormat = [
				structureColumn.get("spis_znak"),
				this.gridFormat.get("spis_pl"),
				this.gridFormat.get("nazev"),
				this.gridFormat.get("poznamka"),
				this.gridFormat.get("skar_znak"),
				this.gridFormat.get("skar_lhuta"),
				this.gridFormat.get("popis"),
				this.gridFormat.get("dat_od"),
				this.gridFormat.get("dat_do"),
				this.gridFormat.get("aktivita_txt"),
			]
			this.treegrid.ggrid({
				data: this.treeview,
				name: "gridSeznamTree",
				dataKey: "spis_pl,spis_znak",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
					name: "doubleClickGridSeznam",
					run: (ev, ctx) => {
						this.openDetail();
					}
				}),
				searchColumns: this.gridSearchColumns,
				columns: treeGridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
				sort: "spis_pl,spis_znak",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});
		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// o�et�en� zav�en� contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

	}

}
